import Quill from 'quill';

export const highlightSearchTerm = (editor: any, searchTerm: string): void => {
    const escapeRegExp = (string: string): string => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    editor.formatText(0, editor.getLength(), 'highlight', false);

    if (searchTerm) {
        const escapedSearchTerm = escapeRegExp(searchTerm);
        const regex = new RegExp(escapedSearchTerm, 'gi');
        const plainText = editor.getText();
        let match;

        while ((match = regex.exec(plainText)) !== null) {
            const [leaf] = editor.getLeaf(match.index) || [];
            if (!leaf) continue;

            const blot = Quill.find(leaf.domNode);

            let isInsideHashtag = false;
            let currentBlot = blot;

            while (currentBlot) {
                if (currentBlot.statics?.blotName === 'hashtag') {
                    isInsideHashtag = true;
                    break;
                }
                currentBlot = currentBlot.parent;
            }

            if (!isInsideHashtag) {
                editor.formatText(match.index, match[0].length, 'highlight', true);
            }
        }
    }
};

export const highlightHashtags = (editor: any) => {
    const regex = /#\w+/g;
    const text = editor.getText();

    // Сбрасываем предыдущие выделения хэштегов
    editor.formatText(0, editor.getLength(), 'hashtag', false);

    let match;
    while ((match = regex.exec(text)) !== null) {
        editor.formatText(match.index, match[0].length, 'hashtag', true);
    }
};
